<template>
    <a-modal  title="修改密码" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" wrap-class-name="single-spa-vue">
        <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <a-form-item label="旧密码" name="oldpassword">
                <a-input-password v-model:value="form.oldpassword" size="large" type="password" placeholder="请输入密码"/>
            </a-form-item>
            <a-form-item label="新密码" name="newpassword">
                <a-input-password v-model:value="form.newpassword" size="large" type="password" placeholder="请输入密码"/>
            </a-form-item>
            <a-form-item label="确认新密码" name="newPasswordTwo">
                <a-input-password v-model:value="form.newPasswordTwo" size="large" type="password" placeholder="请输入密码"/>
            </a-form-item>
        </a-form>
        <!-- <div>
            <span>确认新密码</span>
            <a-input-password v-model:value="inputValue" size="large" type="password" placeholder="请输入密码"/>
            <span style="color: red" v-if="passwordShow">两次输入密码不一致</span>
        </div> -->
        
    </a-modal>
        <!--可编辑区域 end-->
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {login_mp, sys_admin} from "@/api/adminService";
    import {ls} from "@/utils/util";

export default {
    name: "EditPasswordModal",
    mixins: [formMixin],
    components: {},
    data() {
        return {
            inputValue: '',
            passwordShow:false,
            form: {
                oldpassword: null,
                newpassword: null,
                newPasswordTwo: null,
            },
            rules: {
                oldpassword: [
                    dataCheck.required({}),
                ],
                newpassword: [
                    dataCheck.required({}),
                ],
                newPasswordTwo: [
                    dataCheck.required({}),
                    {validator: this.compareToFirstPassword}
                ],
            },
            // submitUrl: sys_admin.changePassword
        }
    },
    methods: {
        async compareToFirstPassword(rule, value) {
            if (value && value !== this.form.newpassword) {
                return Promise.reject('两次输入密码不一致');
            } else {
                return Promise.resolve();
            }
        },
        onSubmit() {
            if(this.inputValue && this.inputValue !== this.form.newpassword){
                this.passwordShow = true
            }else{
                this.passwordShow = false;
                this.$refs.ruleForm
                    .validate().then((values) => {
                    let self = this;
                    self.postAction({
                        url: sys_admin.changePassword,
                        params:{
                            id:'',
                            oldpassword:values.oldpassword,
                            newpassword:values.newpassword
                        }
                    }).then(res=>{
                        if(res){
                            console.log(86);
                            this.$notification['success']({
                                    message: '密码已更改',
                                style: {
                                    fontWeight: '600',
                                },
                                });
                            let self = this;
                            
                        self.postAction({
                            url: login_mp.saveLog,
                            params: {logAppCategoryEnum: "LOGOUT"}
                        }).then(res => {
                            console.log(res)
                            self.getAction({
                                url: login_mp.logout,
                                params: {access_token: ls.get("token") || ""},
                                isValid: false
                            }).then(() => {
                                self.$notification['success']({
                                    message: '退出成功',
                                style: {
                                    fontWeight: '600',
                                },
                                });
                            })
                        })


                        setTimeout(() => {

                            self.$ls.clear();
                            self.$store.commit('setMenuData', []);
                            this.$router.push({ path: '/login', query: { id: 'user' } })
                        }, 2000)
                        }
                    })
                })
            }

        }
    },
}
</script>
<style scoped lang="less">
</style>
